import { computed, inject, provide, type ComputedRef, type InjectionKey, type Ref } from "vue";

// Set on <Table dense>, read by the head/cell primitives below it.
export const tableDenseKey: InjectionKey<Ref<boolean>> = Symbol("tableDense");

export function provideTableDense(dense: Ref<boolean>) {
  provide(tableDenseKey, dense);
}

export function useTableDense(): ComputedRef<boolean> {
  const dense = inject(tableDenseKey, null);
  return computed(() => dense?.value ?? false);
}
